import { Route } from '@angular/router';
import { AuthGuard } from './auth/auth-guard/auth.guard';

export const appRoutes: Route[] = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () =>
      import('src/app/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('src/app/main/main.routes').then((m) => m.mainRoutes),
    canActivate: [AuthGuard],
  },
];
